@for (toast of toasts(); track toast.id) {
  <portal-toast @slideInOut [toast]="toast"></portal-toast>
}
